import React, { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { validation, validationText } from "../../utils/constants.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSelect from "../ThemeComponent/ThemeSelect";
import { errorToast, success } from "../../utils/helpers.js";
import {
  useAddStaffMutation,
  useUpdateStaffMutation,
} from "../../Redux/services/ClientAPis/staffApi";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";
import ThemeTextArea from "../ThemeComponent/ThemeTextArea";

const AddStaff = ({ setIsOpen, modalData, refetch }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const [addStaff, { isLoading: addLoading }] = useAddStaffMutation();
  const [updateStaff, { isLoading }] = useUpdateStaffMutation();

  const options = [
    { label: "Doctor", value: "Doctor" },
    { label: "Helper", value: "Helper" },
    { label: "Nurse", value: "Nurse" },
  ];

  const onSubmit = async (data) => {
    const payload = { ...data, id: modalData?.id };
    try {
      let response;
      if (modalData) {
        response = await updateStaff(payload);
      } else {
        response = await addStaff(data);
      }

      if (response.data.code === 200) {
        setIsOpen(false);
        refetch();
        success(
          response?.data?.message || modalData
            ? "Client Updated SUccessfully"
            : "Client Added Successfully"
        );
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (modalData) {
      setValue("name", modalData.name);
      setValue("email", modalData.email);
      setValue("mobile_no", modalData.mobile_no);
      setValue("username", modalData.username);
      setValue("password", modalData.password_view);
      setValue("designation", modalData.designation);
      setValue("notes", modalData.notes);
    } else {
      reset();
    }
  }, []);
  return (
    <div className="edit-profile-content">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-edit-profile mt-2"
      >
        <ThemeInput
          name="name"
          errors={errors}
          control={control}
          type={"text"}
          className={""}
          placeholder={"Full Name"}
          rules={{
            required: {
              value: true,
              message: validationText.nameRequired,
            },
            maxLength: {
              value: validation.nameMax,
              message: validationText.nameMax,
            },
          }}
        />
        <ThemeInput
          name="email"
          errors={errors}
          control={control}
          type={"email"}
          className={"mt-3"}
          placeholder={"Email Address"}
          rules={{
            required: {
              value: true,
              message: validationText.emailRequired,
            },
            maxLength: {
              value: validation.emailMax,
              message: validationText.emailMax,
            },
          }}
        />
        <ThemeInput
          name="mobile_no"
          errors={errors}
          control={control}
          type={"number"}
          className={"mt-3"}
          placeholder={"Phone Number"}
          rules={{
            required: {
              value: true,
              message: validationText.phoneNumber,
            },
            maxLength: {
              value: validation.phoneNumberMax,
              message: validationText.phoneNumberMax,
            },
          }}
        />
        <ThemeTextArea
          name="notes"
          errors={errors}
          control={control}
          type={"testarea"}
          className={""}
          placeholder={"Notes"}
          as={"textarea"}
          row={10}
          // rules={{
          //   required: {
          //     value: true,
          //     message: validationText.phoneNumber,
          //   },
          //   maxLength: {
          //     value: validation.phoneNumberMax,
          //     message: validationText.phoneNumberMax,
          //   },
          // }}
        />

        <ThemeSelect
          name="designation"
          control={control}
          label="Select Position"
          options={options}
          rules={{ required: "Designation is required" }}
          errors={errors}
          placeholder="Select"
          className={"mt-3"}
        />
        <div className="d-flex gap-3 mt-4">
          <div className="btn-submit w-50">
            <Button
              className="cancel-btn w-100 bg-grey"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="btn-submit w-50">
            <Button
              disabled={isLoading}
              type="submit"
              className="theme-btn w-100"
            >
              {isLoading || addLoading ? (
                <ThemeSpinner />
              ) : modalData ? (
                "Update Staff"
              ) : (
                "Add Staff"
              )}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddStaff;
